const hebrewFontFaceCss: string = `
@font-face {
  font-family: "IBM Plex Sans Hebrew";
  src: url("/fonts/plex-sans-hebrew/fonts/complete/woff2/IBMPlexSansHebrew-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "IBM Plex Sans Hebrew";
  src: url("/fonts/plex-sans-hebrew/fonts/complete/woff2/IBMPlexSansHebrew-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "IBM Plex Sans Hebrew";
  src: url("/fonts/plex-sans-hebrew/fonts/complete/woff2/IBMPlexSansHebrew-SemiBold.woff2") format("woff2");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "IBM Plex Sans Hebrew";
  src: url("/fonts/plex-sans-hebrew/fonts/complete/woff2/IBMPlexSansHebrew-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
`;

export {};

if (typeof document !== 'undefined' && !document.querySelector('style[data-hebrew-ui-font]')) {
  const style: HTMLStyleElement = document.createElement('style');
  style.dataset.hebrewUiFont = 'true';
  style.textContent = hebrewFontFaceCss;
  document.head.appendChild(style);
}
